module.exports = __webpack_public_path__ + "static/media/butcher-1.c336de54.png";